var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiechtenstein(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0.695625 16 16 13.913 16 13.913L32 16Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8256 11.1304C11.8256 9.97786 10.8912 9.04349 9.73866 9.04349C9.20397 9.04349 8.71666 9.24474 8.34735 9.5753V8.3478H9.04297V6.95649H8.34735V6.26086H6.95603V6.95649H6.26041V8.3478H6.95603V9.5753C6.58672 9.24474 6.09941 9.04349 5.56472 9.04349C4.41216 9.04349 3.47778 9.97786 3.47778 11.1304C3.47778 11.7484 3.7466 12.3034 4.17341 12.6855V13.913H11.1299V12.6855C11.5568 12.3034 11.8256 11.7484 11.8256 11.1304V11.1304Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiechtenstein);
export default __webpack_public_path__ + "static/media/liechtenstein.43aeca49.svg";
export { ForwardRef as ReactComponent };